module.exports = __webpack_public_path__ + "img/telemedecine.8960d0d4.png";